import { getRequest } from "./utils";

const $ = window.jQuery;
const modal = $("#js-popup-modal");
const csrfToken = $("meta[name='csrf-token']").attr("content");

export default function user() {
	modal.on("show.bs.modal", () => {
		$(".body").css("overflow", "hidden");
	});

	modal.on("hide.bs.modal", () => {
		$(".body").css("overflow", "");
	});

	const $enterInputs = $(".form-group input");

	$.each($enterInputs, (i, item) => {
		const element = $(item);
		if (element.val()) {
			element.next().addClass("inactive");
		}
	});
	$(document).on("click", ".js-enter-visible-password", e => {
		const element = $(e.currentTarget);
		const input = element.parents(".enter__block").find(".enter__input");
		element.toggleClass("active");

		if (input.attr("type") === "text") {
			input.attr("type", "password");
		} else {
			input.attr("type", "text");
		}
	});

	$(".checkbox__input").on("keydown", e => {
		const element = $(e.currentTarget);
		element.removeAttr("checked");

		if (e.code === "Enter" || e.code === "NumpadEnter") {
			element.toggleClass("checked");
		}
	});

	$(document).on("click", ".js-login-back", () => {
		$("#recoveryModal").modal("hide");
		$("#loginModal").modal("show");
	});

	$(".js-enter-register").on("click", () => {
		$("#loginModal").modal("hide");
	});

	$(".js-enter-recovery").on("click", () => {
		$("#loginModal").modal("hide");
	});

	$(".js-enter-login").on("click", () => {
		$("#registerModal").modal("hide");
	});

	$(document).on("click", ".js-order-revert", e => {
		const el = $(e.currentTarget);
		const order_id = el.data("order");
		const event_id = el.data("event");
		getRequest("/event/cart/remove-event", { event_id, order_id }, "POST").then(
			response => {
				if (response.success === 1) {
					console.warn("успешно");
					location.reload();
				} else if (response.error === 1) {
					$(".js-order-message").text(response.message);
					$(".js-order-message")
						.parents(".order__message")
						.show();
				}
			},
			error => {
				console.error(error);
			},
		);
	});
}
